<!--================================
=            BASEHEADER            =
=================================-->

<template>
<div>
  <v-app-bar clipped-right class="transparent mb-10 " flat height="65">
    <v-app-bar-nav-icon class="text-sm-body-2 d-flex d-sm-none white--text" @click="drawer = true"></v-app-bar-nav-icon>

    <v-container class="py-0 fill-height ">
      <v-toolbar-title class="ml-n7">
        <v-list-item dark two-line>
          <v-list-item-content>
            <v-list-item-title class="">
              <h2 class="text-lg-h5 font-weight-medium">
                <slot name="page-header"></slot>
              </h2>
              <v-row>
                <p class="ml-3 mt-3 text-caption  font-weight-light">Home /</p>
                <div class="pl-1 mt-3 text-caption font-weight-light " style="width:200px">
                  <slot name="page-header"></slot>
                </div>
              </v-row>
            </v-list-item-title>

          </v-list-item-content>

        </v-list-item>
      </v-toolbar-title>

      <v-spacer style="margin-left:460px"></v-spacer>

      <div max-width="260" class="text-right align-end ml-15 justify-end">
        <v-text-field class="mr-2 rounded-lg align-end  d-none d-lg-block justify-end" dark prepend-inner-icon="mdi-magnify" dense flat hide-details rounded-lg
                      solo-inverted></v-text-field>
      </div>
      <base-menu-top></base-menu-top>
    </v-container>
  </v-app-bar>
      <v-navigation-drawer hide-overlay elevation="4"   v-model="drawer" dark  style="height:1200px;   position: fixed;
    z-index: 5;" absolute temporary
    >
     <drawer-vertical></drawer-vertical>
    </v-navigation-drawer></div>
</template>
<script>
  import BaseMenuTop from './BaseMenuTop'
  import DrawerVertical from '../Drawer/DrawerVertical'
  export default {
    name: "base-header",
    components: {
      BaseMenuTop,
      DrawerVertical
    },
    data: () => ({  drawer: false,
      group: null,
      picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      item: [{
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Link 1',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },

      ],
      items: [{
          title: 'Click Me'
        },
        {
          title: 'Click Me'
        },
        {
          title: 'Click Me'
        },
        {
          title: 'Click Me 2'
        },
      ],
    }),
  };
</script>
<style scoped>
  .main-img {
    background-image: url('../../assets/images/theme.jpg');
    background-size: 100%
  }

  .base-header {
    margin-top: 180px;
    margin-bottom: 20px;
    margin-left: 20px;
  }

  .page-header {
    font-size: 22px;
    font-weight: bolder;
    color: "primary";

  }

  .text-page {
    width: 200px !important
  }
</style>
<!--====  End of BASEHEADER  ====-->